import { render } from "./ConfigTable.vue?vue&type=template&id=0f443eef&ts=true"
import script from "./ConfigTable.vue?vue&type=script&lang=ts"
export * from "./ConfigTable.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__